import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';

@Component({
  standalone: false,
  selector: 'app-logout',
  template: ''
})
export class LogoutComponent implements OnInit
{
  constructor(
    private authService: AuthenticationService,
    private router: Router)
  { }

  public ngOnInit(): void
  {
    if (this.authService.isAuthenticated)
    {
      this.authService.reset(true);
    }

    this.router.navigate(['/login']);
  }
}
